module.exports = __webpack_public_path__ + "static/logo-dbd1caf702a39a554ca01b429614a4e8.png";